export default "__VITE_ASSET__rMAm2v30__"